"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _weirDls = require("@weirgroup/weir-dls");
var _mineSitesconstants = require("./mineSitesconstants");
var _reactRedux = require("react-redux");
var _manageYourTeam = require("../manageYourTeam.action");
var _mineSitesModule = _interopRequireDefault(require("./mineSites.module.css"));
var _languageMsg = _interopRequireDefault(require("../viewusers/languageMsg"));
var _accessRequests = require("../accessRequests");
class MineSitesPage extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbHistoryData: {},
      breadcrumbData: [],
      tableHeaders: [],
      tableSrcData: [],
      manageTeamTitle: _mineSitesconstants.CONSTANTS.MANAGE_TEAM_TITLE
    };
    this.breadcrumbInitialize = this.breadcrumbInitialize.bind(this);
    this.navigatetoViewUsers = this.navigatetoViewUsers.bind(this);
    this.parentBusinessEntityClick = this.parentBusinessEntityClick.bind(this);
    this.breadcrumbNavigate = this.breadcrumbNavigate.bind(this);
  }
  componentDidMount() {
    this.props.getBusinessEntities(this.props.applicationID, this.props.sourceSystemName);
    this.props.getRolesForSelectedApp(this.props.applicationID);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.businessEntities !== this.props.businessEntities) {
      this.setState({
        tableSrcData: this.props.businessEntities
      });
      this.breadcrumbInitialize();
    }
  }
  breadcrumbInitialize() {
    const breadCrumbData = [_mineSitesconstants.CONSTANTS.BUSINESS_ENTITY.replace('<MineSiteLabel>', this.props.mineSiteLabel.singular)];
    if (this.state.breadcrumbData !== breadCrumbData) this.setState({
      breadcrumbData: breadCrumbData
    });
  }
  navigatetoViewUsers(item) {
    this.props.viewUsersCallback(item);
    this.breadcrumbInitialize();
  }
  breadcrumbNavigate(item) {
    const selectedBreadCrumb = this.state.breadcrumbHistoryData[item];
    this.setState({
      tableSrcData: selectedBreadCrumb ? selectedBreadCrumb.businessEntities : this.props.businessEntities
    });

    // update breadcrumb
    const breadcrumbItems = this.state.breadcrumbData.slice(0, this.state.breadcrumbData.indexOf(item) + 1);
    this.setState({
      breadcrumbData: breadcrumbItems
    });
  }
  parentBusinessEntityClick(data) {
    var _data$viewUsers$sourc, _data$viewUsers$sourc2, _data$viewUsers$sourc3, _data$viewUsers$sourc4, _data$viewUsers$sourc5;
    this.setState({
      tableSrcData: (_data$viewUsers$sourc = data.viewUsers.source) === null || _data$viewUsers$sourc === void 0 ? void 0 : _data$viewUsers$sourc.children,
      breadcrumbHistoryData: {
        ...this.state.breadcrumbHistoryData,
        [(_data$viewUsers$sourc2 = data.viewUsers.source) === null || _data$viewUsers$sourc2 === void 0 ? void 0 : _data$viewUsers$sourc2.sourceSystemBusinessEntityDisplayName]: {
          title: _mineSitesconstants.CONSTANTS.BUSINESS_ENTITY.replace('<MineSiteLabel>', this.props.mineSiteLabel.singular),
          nodeID: (_data$viewUsers$sourc3 = data.viewUsers.source) === null || _data$viewUsers$sourc3 === void 0 ? void 0 : _data$viewUsers$sourc3.nodeId,
          businessEntities: (_data$viewUsers$sourc4 = data.viewUsers.source) === null || _data$viewUsers$sourc4 === void 0 ? void 0 : _data$viewUsers$sourc4.children
        }
      },
      breadcrumbData: [...this.state.breadcrumbData, (_data$viewUsers$sourc5 = data.viewUsers.source) === null || _data$viewUsers$sourc5 === void 0 ? void 0 : _data$viewUsers$sourc5.sourceSystemBusinessEntityDisplayName]
    });
  }
  renderTable(results) {
    const tableDataSrcData = [];
    const APIResponse = results;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < APIResponse.length; i++) {
      tableDataSrcData.push({
        minesite: APIResponse[i].sourceSystemBusinessEntityDisplayName || '--',
        viewUsers: APIResponse[i],
        onClickViewUsers: this.navigatetoViewUsers,
        parentBusinessEntityClick: this.parentBusinessEntityClick
      });
    }
    return tableDataSrcData;
  }
  render() {
    var _this$state$breadcrum;
    const header = [{
      id: 1,
      label: this.props.mineSiteLabel.singular,
      key: 'minesite',
      type: 'string',
      sortable: true,
      filterable: true,
      renderFn(data) {
        var _data$viewUsers$sourc6;
        return /*#__PURE__*/_react.default.createElement(_weirDls.TitleContextCard, {
          title: /*#__PURE__*/_react.default.createElement("div", {
            "data-test": "bName-Descr"
          }, data.viewUsers.source.sourceSystemBusinessEntityDisplayName),
          context: data.viewUsers.source.sourceSystemBusinessEntityDescription,
          isActive: (_data$viewUsers$sourc6 = data.viewUsers.source) === null || _data$viewUsers$sourc6 === void 0 || (_data$viewUsers$sourc6 = _data$viewUsers$sourc6.children) === null || _data$viewUsers$sourc6 === void 0 ? void 0 : _data$viewUsers$sourc6.length,
          onSelect: () => {
            data.parentBusinessEntityClick.source(data);
          }
        });
      }
    }, {
      id: 2,
      label: _languageMsg.default.VIEW_USERS,
      key: 'viewUsers',
      type: 'string',
      filterable: false,
      sortable: false,
      renderFn(data) {
        var _data$viewUsers$sourc7;
        return ((_data$viewUsers$sourc7 = data.viewUsers.source) === null || _data$viewUsers$sourc7 === void 0 || (_data$viewUsers$sourc7 = _data$viewUsers$sourc7.children) === null || _data$viewUsers$sourc7 === void 0 ? void 0 : _data$viewUsers$sourc7.length) === 0 && /*#__PURE__*/_react.default.createElement(_weirDls.Button, {
          label: _languageMsg.default.VIEW_USERS,
          variant: "tertiary",
          onClick: () => data.onClickViewUsers.source(data.viewUsers.source)
        });
      }
    }];
    const tabItems = [{
      title: _mineSitesconstants.CONSTANTS.ALL_USERS,
      component: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        "data-test": "minesites-subheading",
        className: _mineSitesModule.default.minesiteSubHead
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _mineSitesModule.default.font14
      }, _mineSitesconstants.CONSTANTS.MINESITE_SUBHEAD.replace('<MineSiteLabel>', this.props.mineSiteLabel.singular))), /*#__PURE__*/_react.default.createElement("div", {
        "data-test": "minesites-table"
      }, ((_this$state$breadcrum = this.state.breadcrumbData) === null || _this$state$breadcrum === void 0 ? void 0 : _this$state$breadcrum.length) > 1 && /*#__PURE__*/_react.default.createElement("div", {
        className: _mineSitesModule.default.breadCrumbWrapper
      }, /*#__PURE__*/_react.default.createElement(_weirDls.BreadCrumb, {
        menuItems: this.state.breadcrumbData,
        onItemClick: item => {
          this.breadcrumbNavigate(item);
        },
        highCountTooltip: _mineSitesconstants.CONSTANTS.BREADCRUMB_MORE_ITEMS_TEXT
      })), this.props.businessEntities.length > 0 && /*#__PURE__*/_react.default.createElement(_weirDls.Table, {
        sortable: true,
        header: header,
        source: this.renderTable(this.state.tableSrcData),
        title: "Available ".concat(this.props.mineSiteLabel.plural),
        searchable: true,
        minSearch: 3,
        searchPlaceHolderOnFocus: 'Enter min. 3 characters',
        searchResultSingle: 'Result',
        searchResultPlural: 'Results',
        noResultsText: 'No Results',
        searchPlaceholder: 'Search',
        serverSideSort: false,
        serverSideSearch: false,
        tableType: 'small'
      }))),
      onClick() {}
    }, {
      title: _mineSitesconstants.CONSTANTS.ACCESS_REQUEST,
      component: /*#__PURE__*/_react.default.createElement(_accessRequests.AccessRequestPage, {
        appId: this.props.applicationID
      }),
      onClick() {}
    }];
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _mineSitesModule.default.wrapper
    }, /*#__PURE__*/_react.default.createElement("div", {
      "data-test": "minesites-heading",
      className: _mineSitesModule.default.minesiteHeading
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _mineSitesModule.default.font20
    }, this.state.manageTeamTitle)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: _mineSitesModule.default.tabsContainer
    }, /*#__PURE__*/_react.default.createElement(_weirDls.Tabs, {
      items: tabItems,
      activeTabIndex: 0
    }))));
  }
}
const mapStateToProps = state => ({
  businessEntities: state.manageYourTeam.businessEntities,
  mineSiteLabel: state.manageYourTeam.mineSiteLabel
});
function mapDispatchToProps(dispatch) {
  return {
    getBusinessEntities: (appID, sourceSystemName) => {
      dispatch((0, _manageYourTeam.getBusinessEntities)(appID, sourceSystemName));
    },
    getRolesForSelectedApp: appID => {
      dispatch((0, _manageYourTeam.getRolesForSelectedApp)(appID));
    }
  };
}
;
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MineSitesPage);